import React from 'react';
import PropTypes from 'prop-types';
import Pill from './Pill';
import { MARKER_TONES, PILL_SIZES } from './tones';

// The exception that keeps a solid fill: something whose whole job is to be noticed first, like
// the "new" flag on a nav item. Everything else is subtle, which is what leaves a marker room to
// stand out at all.
export default function MarkerPill({ tone, size, title, className, children }) {
  return (
    <Pill toneClass={MARKER_TONES[tone]} size={size} shape="pill" title={title} className={className}>
      {children}
    </Pill>
  );
}

MarkerPill.propTypes = {
  tone: PropTypes.oneOf(Object.keys(MARKER_TONES)),
  size: PropTypes.oneOf(PILL_SIZES),
  title: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

MarkerPill.defaultProps = {
  tone: 'danger',
  size: 'inline',
  title: undefined,
  className: '',
};
